export class CompanyDistrictUpdateRefusalReasonDto {
  nameKr?: boolean;
  nameEng?: boolean;
  address?: boolean;
}
